import React from 'react';
import { PhotoIcon } from '@heroicons/react/24/outline';

const Media: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Media</h1>
      <p className="section-description">
        Manage and organize media files, including images, videos, and other digital assets.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <PhotoIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Media Management</h3>
              <p className="feature-description">
                Handle media files and assets:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Upload and organize media</li>
                <li>Edit and optimize files</li>
                <li>Manage file metadata</li>
                <li>Control media access</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <PhotoIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Media Library</h3>
              <p className="feature-description">
                Organize and categorize media:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create media collections</li>
                <li>Apply media tags</li>
                <li>Set usage permissions</li>
                <li>Track media usage</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Optimize media files for web</li>
            <li>Use descriptive file names</li>
            <li>Maintain organized folder structure</li>
            <li>Regularly clean up unused media</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Media; 